var _linearGradient, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 2.794,
    x2: 25.809,
    y1: 29.867,
    y2: 5.701
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e0a5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 1a15 15 0 1 0 15 15 15 15 0 0 0 -15-15zm.643 9.214a5.149 5.149 0 0 1 5.143 5.143h-1.286a3.861 3.861 0 0 0 -3.857-3.857zm4.165 14.786c-.039 0-3.9-.066-8.865-4.943-4.877-4.963-4.943-8.826-4.943-8.865 0-.481 3-4.192 3.663-4.192.23 0 .409.156.605.39.472.562 2.559 3.856 2.463 4.405-.046.258-.265.454-.893.981a7.416 7.416 0 0 0 -.866.8 6.906 6.906 0 0 0 .566 1.526 9.435 9.435 0 0 0 4.362 4.36 6.906 6.906 0 0 0 1.526.566 7.416 7.416 0 0 0 .8-.866c.527-.628.723-.847.981-.893.549-.1 3.843 1.991 4.405 2.463.234.2.39.375.39.605-.002.663-3.713 3.663-4.194 3.663zm2.906-9.643a7.079 7.079 0 0 0 -7.071-7.071v-1.286a8.367 8.367 0 0 1 8.357 8.357z",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2ee1b7611b7f067c6465ffd652962c51.svg";
export { ForwardRef as ReactComponent };